<template>
    <div
        class="
            tw-h-full tw-w-full tw-shadow tw-p-0 tw-pb-1 tw-m-0 tw-bg-gray-100
        "
        style="height: 50%; min-height: 200px; background-color: whitesmoke"
    >
        <b-card no-body class="tw-h-full tw-w-full tw-p-0 tw-m-0">
            <b-tabs card fill>
                <b-tab title="Missed Visits">
                    <b-card-text>
                        <h6 class="tw-font-bolder tw-mb-0 text-center">
                            Total Missed Visits
                        </h6>
                        <p class="text-secondary tw-text-xs text-center">
                            Total
                        </p>
                        <h1
                            class="
                                tw-text-6xl tw-font-bolder
                                text-center
                                tw-mb-0
                            "
                        >
                            {{ missed_visit_count }}
                        </h1>
                    </b-card-text>
                </b-tab>

                <b-tab title="1st Missed">
                    <b-card-text>
                        <!-- <div
                            v-if="one_missed_items.length"
                            class="
                                tw-flex
                                tw-items-end
                                tw-justify-end
                                tw-border-b
                                tw-border-gray-400
                                tw-mb-2
                                tw-pb-2
                            "
                        >
                            <b-button @click="downloadFile(1)">
                                Download
                            </b-button>
                        </div> -->

                        <b-table
                            striped
                            borderless
                            :items="one_missed_items"
                            :fields="fields"
                            class="table-sm tw-text-sm"
                        >
                            <template v-slot:cell(contacted)="data">
                                <b-button size="sm" @click="contacted(data.item.id)">
                                    <i class="fas fa-check"></i>
                                </b-button>
                            </template>
                        </b-table>
                    </b-card-text>
                </b-tab>
                <b-tab title="2nd Missed">
                    <b-card-text>
                        <!-- <div
                            v-if="two_missed_items.length"
                            class="
                                tw-flex
                                tw-items-end
                                tw-justify-end
                                tw-border-b
                                tw-border-gray-400
                                tw-mb-2
                                tw-pb-2
                            "
                        >
                            <b-button @click="downloadFile(2)">
                                Download
                            </b-button>
                        </div> -->

                        <b-table
                            striped
                            borderless
                            :items="two_missed_items"
                            :fields="fields"
                            class="table-sm tw-text-sm"
                        >
                            <template v-slot:cell(contacted)="data">
                                <b-button size="sm" @click="contacted(data.item.id)">
                                    <i class="fas fa-check"></i>
                                </b-button>
                            </template>
                        </b-table>
                    </b-card-text>
                </b-tab>
            </b-tabs>

            <div class="tw-mt-auto tw-flex tw-justify-end">
                <info-popover>
                    <template v-slot:title> Missed Visits </template>
                    <h5>Tab 1: Missed Visits</h5>
                    <p>Total number of Missed Visits today.</p>
                    <h5>Tab 2: 1st Missed</h5>
                    <p>List of 1st Missed Visits and the contacts.</p>
                    <h5>Tab 3: 2nd Missed</h5>
                    <p>List of 2nd Missed Visits and the contacts.</p>
                </info-popover>
            </div>
        </b-card>
    </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

export default {
    mixins: [],
    computed: {},
    data() {
        return {
            missed_visit_count: 0,
            //   fields: [
            //     {
            //       key: "subject_name",
            //       label: "Name"
            //     },
            //     {
            //       key: "head_of_household",
            //       label: "Guardian"
            //     },
            //     {
            //       key: "telephone_number",
            //       label: "Phone"
            //     },
            //   ],
            fields: ["name", "guardian", "phone", "contacted"],
            one_missed_items: [],
            two_missed_items: [],
        };
    },
    created: function () {},
    mounted: function () {
        this.get();
    },
    methods: {
        get: function () {
            const that = this;
            HTTP.get("/kenya/metrics/missed-visit-count").then((response) => {
                that.missed_visit_count = response.data.count;
            });

            HTTP.get("/kenya/metrics/one-missed-visit").then((response) => {
                that.one_missed_items = response.data;
            });

            HTTP.get("/kenya/metrics/two-missed-visit").then((response) => {
                that.two_missed_items = response.data;
            });
        },
        downloadFile: function (missed) {
            let downloadUrl = `${process.env.VUE_APP_AXIOS_BASE_URL}/kenya/metrics/download-missed-visit?missed=${missed}`;
            HTTP.get(downloadUrl)
                .then((response) => {
                    var fileURL = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    var fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute(
                        "download",
                        `missed-visits-${missed}.csv`
                    );
                    document.body.appendChild(fileLink);
                    fileLink.click();
                })
                .catch((error) => {
                    HandleErrors.HandleErrors(error);
                });
        },
        contacted: function (id) {
            const that = this;

            if (!confirm("Are you sure you have contacted this individual?")) {
                return;
            }

            HTTP.post(`/kenya/metrics/missed-visit-contacted`, {
                id: id,
            })
                .then(() => {
                    that.get();                    
                })
                .catch((error) => {
                    HandleErrors.HandleErrors(error);
                });
        },
    },
};
</script>

<style>
nav.card-header {
    border-bottom: none;
    padding: 0.5rem 0 0 0;
}
ul.nav.nav-tabs {
    padding: 0 0.5rem;
}
ul.nav.nav-tabs li.nav-item {
    font-size: 0.7rem;
}
ul.nav.nav-tabs a.nav-link {
    padding: 0.35rem 0.5rem;
}
</style>
